import { axiosInstance } from './api';

/**
 * EZVIZ pan/tilt control. Mirrors the BE endpoint at
 * ``services/plugins/equipment_discovery/api/vendor_params.py::camera_ptz``.
 *
 * Moves are server-timed nudges (one POST per tap, the BE starts and
 * stops the motor). ``save``/``goto`` use the camera's own preset slot:
 * the remembered position is stored in the device, not in our DB.
 */
export type PtzAction = 'up' | 'down' | 'left' | 'right' | 'save' | 'goto';

export const postCameraPtz = (
  id: number | string,
  action: PtzAction,
  durationMs?: number,
) => axiosInstance.post<{ ok: boolean }>(
  `/equipment_discovery/cameras/${id}/ptz/`,
  durationMs != null ? { action, duration_ms: durationMs } : { action },
);
